export default class ReadMore {
  constructor(node) {
    this.element = node;

    this.icon = this.element.querySelector(".icon");
    this.text = this.element.querySelector("span");

    this.initialize();
  }

  initialize() {
    this.element.addEventListener("click", () => {
      if (this.element.ariaExpanded == "true") {
        this.text.innerText = this.element.dataset.expandedText;
        this.icon.className = "icon icon-minus";
      } else {
        this.icon.className = "icon icon-plus";
        this.text.innerText = this.element.dataset.closedText;
      }
    });
  }
}
